import type {CounterV1} from '@deezer/logcenter';
import {
	RECLog,
	RECLogContext,
	COUNTER_TYPE,
	COUNTER_VERSION,
	CounterMetrics,
} from '@deezer/logcenter';

const recLogContext = new RECLogContext({
	name: 'mdy',
	version: '1.0.0',
});

type DisconnectPayload = {
	tags: Record<string, string>;
};

class MdyDebugMetrics extends RECLog<CounterV1> {
	private _counter: CounterMetrics;

	constructor(params: DisconnectPayload) {
		super({
			type: COUNTER_TYPE,
			version: COUNTER_VERSION,
			...recLogContext,
		});

		this._counter = new CounterMetrics({
			id: 'mdy.debug',
			tags: params.tags,
		});
	}

	increment() {
		this._counter.increment();
	}

	reset() {
		this._counter.reset();
	}

	serialize() {
		return {
			...super.serialize(),
			metric: {
				id: this._counter.id,
				tags: this._counter.tags,
			},
			counter: this._counter.value,
		};
	}
}

export default MdyDebugMetrics;
